export default __webpack_public_path__ + "static/jo-131c21172c7ee52b20474ed953e6662f.svg";